import React from 'react'
import {reduxForm, formValueSelector, FormSection, Field} from 'redux-form'
import {Section, TextField, RadioField} from 'jbc-front/components/Form'
import compose from 'lodash/fp/compose'
import Modal from 'jbc-front/components/CommonModal'
import Button from 'jbc-front/components/Button'
import {connect, useSelector} from 'react-redux'
import {CardInfo, CardInput} from './CardInput'
import {email} from 'validators'
import api from 'api'
import {getState} from 'utils'
import {actionCreators} from 'actions'
import moment from 'moment'
import {asyncError} from 'store/actions/asyncError'
import styles from './PaymentMethodForm.scss'

const formName = 'PaymentMethodChange'
const selector = formValueSelector(formName)

export const paymentMethodTypes = [{label: 'クレジットカード支払い', value: 'credit_card'}]

const PaymentMethodForm = ({submitting, handleSubmit, cardInfo, hideModal, dispatch}) => {
  const currentUser = useSelector((state) => state.session.currentUser)
  const changeFrom = moment()
  if (changeFrom.date() <= 1) {
    changeFrom.subtract(1, 'month')
  }
  const isAgreed = useSelector((state) => selector(state, 'agreed'))
  return (
    <React.Fragment>
      <Modal.Body>
        <div className={styles.paymentMethodFormNotice}>
          <p>
            【注意】
            <br />
            ジョブカン会計有料プランをご契約中のお客様は、
            <br />
            クレジットカード支払いに変更すると特典が適用されません。
          </p>
        </div>
        <Section title="決済方法">
          <RadioField name="payment_method_type" options={paymentMethodTypes} />
          請求書払いをご希望の方はサポート窓口までお問い合わせください。
        </Section>
        <Section title="決済情報">
          <Section title="個人情報の第三者提供について">
            <div className={styles.list}>
              <div className={styles.row}>
                当社がお客様から収集した以下の個人情報等は、カード発行会社が行う不正利用検知・防止のために、お客様が利用されているカード発行会社へ提供させていただきます。
              </div>
              <div className={styles.row}>氏名、電話番号、email アドレス、インターネット利用環境に関する情報 等</div>
              <div className={styles.row}>
                お客様が利用されているカード発行会社が外国にある場合、これらの情報は当該発行会社が所属する国に移転される場合があります。当社では、お客様から収集した情報からは、ご利用のカード発行会社及び当該会社が所在する国を特定することができないため、以下の個人情報保護措置に関する情報を把握して、ご提供することはできません。
              </div>
              <div>・提供先が所在する外国の名称</div>
              <div>・当該国の個人情報保護制度に関する情報</div>
              <div>・発行会社の個人情報保護の措置</div>
            </div>
            <CheckboxFields
              name="agreed"
              label="上記の「個人情報の第三者提供について」に同意する。"
              disabled={cardInfo}
            />
          </Section>
          <FormSection name="credit_info">
            <CardInput dispatch={dispatch} formName={formName} email={currentUser.email} disabled={!isAgreed} />
            {cardInfo && <CardInfo cardInfo={cardInfo} />}
            <TextField name="employee_email" label="メールアドレス" validate={email} required />
            <div className={styles.hintMessage}>
              利用プラン変更やカード情報を登録すると、このメールアドレス宛に通知されます。
            </div>
            変更された決済情報は{changeFrom.format('YYYY年M月')}利用分（
            {changeFrom.clone().add(1, 'month').format('YYYY年M月')}ご請求）から反映されます。
          </FormSection>
        </Section>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Buttons>
          <Button onClick={hideModal} disabled={submitting}>
            キャンセル
          </Button>
          <Button primary onClick={handleSubmit} disabled={submitting || !cardInfo || !isAgreed}>
            登録する
          </Button>
        </Modal.Buttons>
      </Modal.Footer>
    </React.Fragment>
  )
}

export default compose(
  reduxForm({
    form: formName,
    enableReinitialize: true,
    onSubmit: async (values, dispatch, {hideModal}) => {
      try {
        const {
          auth: {token},
        } = await getState(dispatch)
        await api.createWithAuth(token).clients.changePaymentMethod(values)
        dispatch(actionCreators.fetchData('payment_info', api.createWithAuth(token).clients.getPaymentInfo()))
      } catch (err) {
        dispatch(asyncError(err))
      }
      hideModal()
    },
  }),
  connect((state) => ({
    cardInfo: selector(state, 'credit_info._card_info'),
  }))
)(PaymentMethodForm)

const CheckboxFields = ({name, label, disabled}) => (
  <label>
    <Field component="input" type="checkbox" name={name} className={styles.checkboxInput} disabled={disabled} />
    <span className={styles.checkboxParts}>{label} </span>
  </label>
)
